// ─────────────────────────────────────────────────────────────────────────────
// UserDetailsStep.js — step 1. The invitee's identity: email + first/last name,
// plus the SSO note.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "../InviteModal.module.css";
import { MailIcon, InfoIcon } from "../icons";

export default function UserDetailsStep({ form, update }) {
  return (
    <>
      <div className={styles.field}>
        <label className={styles.label}>Email Address <span className={styles.req}>*</span></label>
        <div className={styles.inputWrap}>
          <span className={styles.inputIcon}><MailIcon size={15} /></span>
          <input
            className={`${styles.input} ${styles.hasIcon}`}
            type="email" placeholder="user@acme.com"
            value={form.email}
            onChange={(e) => update({ email: e.target.value })}
          />
        </div>
      </div>

      <div className={styles.fieldRow}>
        <div className={styles.field}>
          <label className={styles.label}>First Name <span className={styles.req}>*</span></label>
          <input
            className={styles.input} placeholder="John"
            value={form.firstName}
            onChange={(e) => update({ firstName: e.target.value })}
          />
        </div>
        <div className={styles.field}>
          <label className={styles.label}>Last Name <span className={styles.req}>*</span></label>
          <input
            className={styles.input} placeholder="Doe"
            value={form.lastName}
            onChange={(e) => update({ lastName: e.target.value })}
          />
        </div>
      </div>

      <div className={`${styles.note} ${styles.noteGreen}`}>
        <span className={styles.noteIcon}><InfoIcon /></span>
        <span>
          If SSO is configured, the user will receive an invite to authenticate via
          your identity provider (Okta).
        </span>
      </div>
    </>
  );
}
